import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { DataTable, } from '../../widgets';
import { usePermission, searchWord } from '../../../helpers/common';
import UserItem from './UserItem';
import { QAPP_ROLE_ID } from '../../../constants';
import { SubNav } from '../../layout/submenu';

const UserList = props => {
    const { userListById, isRequesting, isCustomerList } = props;
    const [includeQapp, setIncludeQapp] = useState(false);
    const [searchText, setSearchText] = useState("");
    const searchInput = React.createRef();

    const allow = usePermission();
    const isAllowEdit = allow("user", "edit") ? true : false;
    const isAllowDelete = allow("user", "delete") ? true : false;

    const handleQappUser = (e) => {
        const { checked } = e.target;
        setIncludeQapp(checked);
    }

    const userListId = Object.keys(userListById).filter(id => ![QAPP_ROLE_ID, 9].includes(userListById[id].role_id));
    const customerUserListId = Object.keys(userListById).filter(id => [9].includes(userListById[id].role_id));
    const qappUserListId = Object.keys(userListById).filter(id => userListById[id].role_id === QAPP_ROLE_ID);
    let filteredUserListId = isCustomerList ? customerUserListId : includeQapp ? [...userListId, ...qappUserListId]
        : userListId;

    const isSearchTextMatched = (id, name) => searchWord(userListById[id][name], searchText);

    if (searchText.trim().length > 0)
        filteredUserListId = filteredUserListId.filter(id => isSearchTextMatched(id, "login") || isSearchTextMatched(id, "role_name") ||
            isSearchTextMatched(id, "first_name") || isSearchTextMatched(id, "last_name") || isSearchTextMatched(id, "meta_data"));

    return <Col className="user-list animate animate__fadeIn">
        <Row className="user-list-header">
            <Col lg={4} md={4} sm={4} className="p-0">
                <SubNav.SearchBox
                    ref={searchInput}
                    placeholder="Search for username, role, first name, last name, data"
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    onClear={() => setSearchText("")}
                />
            </Col>
            <Col className="p-0">
                {!isCustomerList && qappUserListId.length !== 0 && <div className="include-qapp-input">
                    <input type="checkbox" id="includeQappUser" onClick={handleQappUser} className="mr-2 mt-2" ></input>
                    <span ><label htmlFor="includeQappUser">Include Q-app users</label></span>
                </div>}
            </Col>
        </Row>
        <Row className="user-list-body">
            <DataTable>
                <DataTable.Header>
                    <DataTable.Row>
                        <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                        <DataTable.Cell>Username</DataTable.Cell>
                        <DataTable.Cell>Role</DataTable.Cell>
                        <DataTable.Cell>First Name</DataTable.Cell>
                        <DataTable.Cell>Last Name</DataTable.Cell>
                        <DataTable.Cell>Data</DataTable.Cell>
                        <DataTable.Cell>Status</DataTable.Cell>
                        <DataTable.Cell>Last Login Date</DataTable.Cell>
                        {(isAllowEdit || isAllowDelete) &&
                            <DataTable.Cell style={{ width: "150px" }}>Actions</DataTable.Cell>}
                        {(isAllowEdit || isAllowDelete) &&
                            <DataTable.Cell>OEM</DataTable.Cell>}
                        <DataTable.Cell className="access-tab">Access</DataTable.Cell>
                        <DataTable.Cell>Permission</DataTable.Cell>

                    </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                    {filteredUserListId.map((userId, i) =>
                        <UserItem key={userId} index={i + 1} userId={userId} isCustomerList={isCustomerList} />)}
                </DataTable.Body>
            </DataTable>
            {isRequesting ? <DataTable.Loading /> :
                filteredUserListId.length === 0 && <DataTable.RecordsNotFound />}
        </Row>
    </Col>
}

const mapStateToProps = state => ({
    isRequesting: state.users.userListById.isRequesting,
    userListById: state.users.userListById.payload
});

export default connect(mapStateToProps)(UserList);